/* eslint-disable max-len */
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/AppStore';
import { ShoppingCartAltIcon } from 'assets/icons';
import { addEasyBasketReferenceRequest } from 'domains/basket/Basket.store';
import { useFetchMultipleReferences } from 'domains/catalog/Catalog.requests';
import { getLastSearchedVehicleKey } from 'domains/catalog/Catalog.store';
import { useFetchEasyBasketOperationDetails } from 'domains/easyBasket/EasyBasket.requests';
import {
  getEasyBasketOperation,
  getEasyBasketSelectedOperationId,
  getEasyBasketSelectedReferencesMap,
} from 'domains/easyBasket/EasyBasket.store';
import OperationHeader from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/common/OperationHeader';
import BrandsPreselection from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/PartsSelection/BrandsPreselection';
import OperationPartItemGroups from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/PartsSelection/OperationPartItemGroups';
import { SBlueButton } from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/PartsSelection/PartsSelection.styled';
import { useGetCategoriziedReferences } from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/utils';
import { Flex, Icon, notifyTop } from 'UI';

const PartsSelection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const operationId = useSelector((state: RootState) => getEasyBasketSelectedOperationId(state));
  const operation = useSelector((state: RootState) => getEasyBasketOperation(state, operationId));
  const operationDetail = useFetchEasyBasketOperationDetails(operationId);
  const partsItems = operationDetail?.basketContent.partsSection.partsItems;
  const vehicleKey = useSelector(getLastSearchedVehicleKey);

  const selectedReferences = useSelector(getEasyBasketSelectedReferencesMap);

  const categoryTabs = useGetCategoriziedReferences(partsItems);

  const allReferences = [
    ...new Set(
      partsItems?.flatMap((partItem) =>
        partItem.parts.flatMap((part) => [
          part.reference,
          ...(part.alternativeParts?.map((alt) => alt.reference) ?? []),
        ]),
      ) ?? [],
    ),
  ];
  useFetchMultipleReferences(allReferences, vehicleKey);

  const handleAddReferencesToCart = () => {
    if (selectedReferences.size === 0) {
      return;
    }
    notifyTop(
      'success',
      <Trans i18nKey={'catalog.easy_basket.tab.parts_selection.added_to_basket.description'}>
        {'The selected references have been added to the cart'}
      </Trans>,
    );

    selectedReferences.forEach((selectedReference) => {
      dispatch(addEasyBasketReferenceRequest({ selectedReference }));
    });
  };

  return (
    <>
      <OperationHeader title={operation?.data?.designation ?? ''} />
      <Flex justify={'space-between'}>
        <BrandsPreselection partsItems={partsItems ?? []} />
        <SBlueButton
          icon={<Icon IconComponent={ShoppingCartAltIcon} size={18} />}
          disabled={selectedReferences.size === 0}
          shape={'semiRound'}
          onClick={handleAddReferencesToCart}
        >
          {t('catalog.easy_basket.tab.parts_selection.add_references.title', 'Add selected references to cart')}
        </SBlueButton>
      </Flex>
      <OperationPartItemGroups partItemGroups={categoryTabs ?? []} />
    </>
  );
};

export default PartsSelection;
